// extracted by mini-css-extract-plugin
export default {"cardTitle":"Placard_cardTitle__Y4wl+","cardSubtitle":"Placard_cardSubtitle__-q09d","firstSeen":"Placard_firstSeen__m8OIv","cardText":"Placard_cardText__3Lf3j"};